export default {
    name: "Sread vs spread",
    data:
    {
        "id": "109fa684-5ca1-4174-98f5-aeab4be45dfc",
        "title": "spread at 12 vs 17",
        "type": "Composite",
        "config": {
            "operator": "Subtract",
            "combine_on": "date",
            "left": {
                "id": "b2cbf0f1-85f7-437e-b294-1d0d88c7daeb",
                "title": "NBP/TTF at 12",
                "type": "Composite",
                "config": {
                    "operator": "Subtract",
                    "combine_on": "date",
                    "left": {
                        "id": "1b5e2545-1fca-4b55-ad52-68865aa038b8",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 21,
                            "product_id": 1,
                            "hour": "12",
                            "start_date": "2025-06-26",
                            "end_date": "2025-08-25"
                        }
                    },
                    "right": {
                        "id": "282d7403-408d-4b7c-b337-7b3047475d37",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 14,
                            "product_id": 1,
                            "hour": "12",
                            "start_date": "2025-06-26",
                            "end_date": "2025-08-25"
                        }
                    }
                }
            },
            "right": {
                "id": "44788592-c4ee-468c-b179-adbcdb54379b",
                "title": "NBP/TTF at 17",
                "type": "Composite",
                "config": {
                    "operator": "Subtract",
                    "combine_on": "date",
                    "left": {
                        "id": "0c2d903f-2021-4c15-9f7e-f673f686efa9",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 21,
                            "product_id": 1,
                            "hour": "17",
                            "start_date": "2025-06-26",
                            "end_date": "2025-08-25"
                        }
                    },
                    "right": {
                        "id": "cf35db14-68f7-478e-be5c-afd5d15eca83",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 14,
                            "product_id": 1,
                            "hour": "17",
                            "start_date": "2025-06-26",
                            "end_date": "2025-08-25"
                        }
                    }
                }
            }
        }
    }


}